import Modal from "react-modal";
import useWindowDimensions from "../../hooks/useWindowsDimensons";
import Button from "../Elements/Button";
import Cross from "../../assets/icons/cross.svg";
import VegIcon from "../../assets/icons/vegIcon.svg";
import NonvegIcon from "../../assets/icons/nonvegIcon.svg";
import { StarIcon } from "@heroicons/react/24/solid";
import { useSelector } from "react-redux";
import { useEffect, useRef } from "react";

const MenuItemModal = ({ visible, onClose, menuData, addMethodCall }) => {
  const currency = useSelector(
    (state) => state?.basicdata?.storedetails?.store_Currency
  );
  const basket = useSelector((state) => state?.basicdata?.basket);
  const {
    inventory_product_Name,
    inventory_product_Description,
    is_bestseller,
    inventory_product_Thumbnail_Image,
    inventory_product_Type,
    inventory_product_Form,
  } = menuData;

  const { width, height } = useWindowDimensions();
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (visible) {
      // Disable scrolling on the body when modal is open
      document.body.style.overflow = "hidden";
    } else {
      // Enable scrolling on the body when modal is closed
      document.body.style.overflow = "auto";
    }

    // Cleanup: Reset when the component is unmounted or modal closes
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [visible]);

  const checkFoodType = () => {
    if (
      inventory_product_Type.toUpperCase() === "N" ||
      inventory_product_Type.toUpperCase() === "NON-VEG" ||
      inventory_product_Type.toUpperCase() === "Non-Veg"
    ) {
      return NonvegIcon;
    } else {
      return VegIcon;
    }
  };

  const onCloseButton = () => {
    onClose(false);
  };

  const addCall = () => {
    onClose(false);
    addMethodCall();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onCloseButton(); // Call the close function
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onCloseButton]);

  return (
    <Modal
      isOpen={visible}
      onRequestClose={onCloseButton}
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-50"
      className="flex justify-end md:justify-center items-end md:items-center px-0 h-full transition-all duration-300 ease-in-out"
    >
      <div
        ref={wrapperRef}
        className="my-0 bg-white w-full md:w-3/4 xl:w-2/5 flex flex-col relative rounded-md"
        style={{
          maxHeight: height * 0.9,
        }}
      >
        <div className="absolute -top-5 -right-5 z-50 hidden md:block">
          <Button
            onClick={onCloseButton}
            className="rounded-full w-10 h-10 bg-white shadow-md flex items-center justify-center"
            style={{ borderRadius: "20px" }}
          >
            <img src={Cross} alt="Close" className="w-5 h-5" />
          </Button>
        </div>

        {inventory_product_Thumbnail_Image && (
          <img
            src={inventory_product_Thumbnail_Image}
            alt={inventory_product_Name || "product"}
            className="w-full object-cover rounded-tl-md rounded-tr-md"
            style={{
              maxHeight: "250px",
              height: "auto",
            }}
            loading="lazy"
          />
        )}

        <div className="flex flex-col px-5 md:px-7 py-7 md:py-6">
          <div className="flex flex-col justify-between">
            <div className="flex justify-between">
              <div>
                <div className="flex items-center">
                  <img
                    className="w-sub_menu_img_width h-sub_menu_img_height sm:w-auto sm:h-sm_sub_menu_img_height lg:h-lg_sub_menu_img_height right-sub_menu_img_right object-contain rounded-sm"
                    loading="lazy"
                    src={checkFoodType()}
                  />
                  <div className="pl-2 font-semibold">
                    {" "}
                    {inventory_product_Name}{" "}
                  </div>
                </div>
                <div className="flex">
                  <div className="font-semibold">
                    {currency}{" "}
                    {
                      menuData[
                        `inventory_product_${basket?.pos_basket_Delivery_Type}_Price`
                      ]
                    }
                  </div>
                  <div
                    className={`${
                      is_bestseller === 1 ? "block ml-5" : "hidden"
                    }`}
                  >
                    <div className="sm:space-y-0 w-7/12">
                      <div className="flex space-x-0 items-center">
                        <div className="mr-1">
                          <StarIcon className="h-4 w-4 text-sub-color" />
                        </div>
                        <div className="w-max text-sub-color mt-0.5 text-xs sm:text-sm font-medium font-inter">
                          Bestseller
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col">
                <Button
                  className={`btn btn-sm px-1.5 border-0 rounded-lg justify-center items-center w-20 md:w-24 gap-2 z-1 float bg-light-shade-3 hover:bg-black hover:text-light-shade-3 text-black`}
                  onClick={addCall}
                >
                  Add
                </Button>
                <div className="text-xxs md:text-xs font-normal text-black cursor-pointer text-center">
                  {inventory_product_Form !== "OnlyMenu" ? "Customize" : ""}
                </div>
              </div>
            </div>
          </div>
          <div className="text-sm font-inter leading-5 mt-1">
            {inventory_product_Description}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MenuItemModal;
